// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const GENERATE_BOLTZGEN_YAML_STEP_SHAPES = [
  {
    stepType: PipelineStepType.GENERATE_BOLTZGEN_YAML,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {},
    outputDataShapes: {
      boltzgenInputYaml: {
        systemName: 'boltzgenInputYaml',
        displayName: 'Boltzgen Input YAML',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      boltzGenInputDict: {
        kind: 'anything',
        required: true
      },
      inputJSONVersion: {
        kind: 'integer',
        required: true
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
